// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .margin-bot{\n  margin-bottom: 15px;\n}\n.emu-label  {\n  font-size: 0.85rem;\n}\n[dir=ltr] .emu-label  {\n  padding-left: 5px;\n}\n[dir=rtl] .emu-label  {\n  padding-right: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
